module.exports = __webpack_public_path__ + "static/media/batiste.43106dd0.png";